import { useNavigate } from 'react-router-dom'

import ArrowLeftIcon from 'assets/icons/ArrowLeft.png'
import ArrowIcon from 'assets/icons/ArrowRight.png'
import { Button } from 'components/Button'

import { DataSources } from './DataSources'
import { OutputObjective } from './OutputObjective'
import { ResourceCards } from './ResourceCards'
import './insightsGathering.scss'

export const InsightsGathering = () => {
  const navigate = useNavigate()

  return (
    <div className="insights-gathering mx-auto flex flex-col items-center gap-10">
      <div className="flex flex-col gap-6 items-center text-center">
        <h1 className="headline-xl">Insights Gathering</h1>
        <p className="body-m w-[724px]">
          The fieldwork is carried out asynchronously among different partners, led by SMEs, over a period of 4-8 weeks.
        </p>
      </div>

      <div className="flex flex-col gap-4 items-start w-full">
        <ResourceCards />
        <OutputObjective />
      </div>

      <DataSources />

      <div className="flex justify-center gap-4">
        <Button
          text="Go to Working Mode Selection"
          color="white"
          iconposition="left"
          icon={<img src={ArrowLeftIcon} alt="Arrow Left" width="16" height="16" />}
          className="mr-2 px-[16px] py-[10px] border-2 z-[2]"
          onClick={() => navigate('/process?Working Mode Selection')}
        />
        <Button
          text="Go to Development"
          iconposition="right"
          icon={<img src={ArrowIcon} alt="Arrow" width="16" height="16" />}
          color="black"
          className="px-[16px] py-[10px] z-[2]"
          onClick={() => navigate('/process?Development')}
        />
      </div>
    </div>
  )
}
